import React from 'react';

const IconCard = ({ className = '', width = '20px', height = '20px' }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 25 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-545.000000, -733.000000)" fill="#74777A">
        <path d="M546.96785,733 L568.03215,733 C569.116166,733 570,733.897041 570,734.995054 L570,748.004946 C570,749.103948 569.115191,750 568.03215,750 L546.96785,750 C545.883834,750 545,749.102959 545,748.004946 L545,734.995054 C545,733.896052 545.883834,733 546.96785,733 Z M561.378647,740.844512 L566.510592,740.844512 C566.845555,740.844512 567.117065,741.119751 567.117065,741.459369 L567.117065,744.765323 C567.117065,745.104917 566.84558,745.380181 566.510592,745.380181 L561.378647,745.380181 C561.043685,745.380181 560.772174,745.104942 560.772174,744.765323 L560.772174,741.459369 C560.772174,741.119776 561.04366,740.844512 561.378647,740.844512 Z M565.904319,742.073238 L561.98417,742.073238 L561.98417,744.150466 L565.904319,744.150466 L565.904319,742.073238 Z M546.212071,736.989982 L568.788179,736.989982 L568.788179,734.994928 C568.788179,734.574124 568.446366,734.228599 568.0323,734.228599 L546.968001,734.228599 C546.552935,734.228599 546.212071,734.574149 546.212071,734.994928 L546.212071,736.989982 Z M568.788179,738.477117 L546.212071,738.477117 L546.212071,748.004895 C546.212071,748.425699 546.552909,748.771223 546.96795,748.771223 L568.03225,748.771223 C568.446316,748.771223 568.788179,748.425673 568.788179,748.004895 L568.788179,738.477117 Z" />
      </g>
    </g>
  </svg>
);

export default IconCard;
